import { getCustomerPlan, isPlanFromBusinessOrEnterpriseCategory } from 'src/data/subscription';
import { useCurrentCustomer } from 'src/store';

export const useIsCustomerOnBusinessOrEnterprisePlan = () => {
  const currentCustomer = useCurrentCustomer();

  const plan = getCustomerPlan(currentCustomer);
  return isPlanFromBusinessOrEnterpriseCategory(plan);
};
